/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total weeks`)
};

const es_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de semanas`)
};

const de_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtwochen`)
};

const nl_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal weken`)
};

const fr_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaines totales`)
};

const it_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimane totali`)
};

const pt_br2_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de semanas`)
};

const pt_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de semanas`)
};

const ja_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総週数`)
};

const zh_dd_weeks = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总周数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_weeks = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_weeks(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_weeks", locale)
	if (locale === "en") return en_dd_weeks(inputs)
	if (locale === "es") return es_dd_weeks(inputs)
	if (locale === "de") return de_dd_weeks(inputs)
	if (locale === "nl") return nl_dd_weeks(inputs)
	if (locale === "fr") return fr_dd_weeks(inputs)
	if (locale === "it") return it_dd_weeks(inputs)
	if (locale === "pt-BR") return pt_br2_dd_weeks(inputs)
	if (locale === "pt") return pt_dd_weeks(inputs)
	if (locale === "ja") return ja_dd_weeks(inputs)
	return zh_dd_weeks(inputs)
};